<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="fleetInfoForm">
        <div class="my-section-box__headline">{{ 'common.value_calculator_flit_info_title' | cxTranslate }}</div>
        <div class="my-section-box fleetInfo" id="fleetInfo">
          <div class="my-section-box-inner fleet-info-block">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <label class="form-label" for="fleetSizeTractors">{{ 'common.value_calculator_fleetSizeTractors' |
                cxTranslate }}</label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-sm-6 pr-0">
                    <input class="fleet-info-input" type="text" formControlName="fleetSizeTractors" />
                    @if (form.fleetSizeTractors.invalid && (form.fleetSizeTractors.dirty || form.fleetSizeTractors.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_cal_fleetSizeTractors_valMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-6 pl-1 EnduTooltip">
                    {{ 'common.value_calculator_tractors_text' | cxTranslate }}
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="tractorTradeInCycle">{{ 'common.value_calculator_tractorTradeInCycle' |
                cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" class="fleet-info-input" formControlName="tractorTradeInCycle" />
                    @if (form.tractorTradeInCycle.invalid && (form.tractorTradeInCycle.dirty || form.tractorTradeInCycle.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_cal_tractorTradeInCycle_valMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EnduTooltip">
                    {{ 'common.value_calculator_year_text' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="fleetSizeTrailers">{{ 'common.value_calculator_fleetSizeTrailers' |
                cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" class="fleet-info-input" formControlName="fleetSizeTrailers" />
                    @if (form.fleetSizeTrailers.invalid && (form.fleetSizeTrailers.dirty || form.fleetSizeTrailers.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_cal_fleetSizeTrailers_valMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EnduTooltip">
                    {{ 'common.value_calculator_trailers_text' | cxTranslate }}
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="trailerTradeInCycle">{{ 'common.value_calculator_trailerTradeInCycle' |
                cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" class="fleet-info-input" formControlName="trailerTradeInCycle" />
                    @if (form.trailerTradeInCycle.invalid && (form.trailerTradeInCycle.dirty || form.trailerTradeInCycle.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_cal_trailerTradeInCycle_valMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EnduTooltip">
                    {{ 'common.value_calculator_year_text' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="airdisk-button-block">
              <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn col-6"
                (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow" alt="">
              {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
              <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn col-6"
                (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>